import { render, staticRenderFns } from "./Decline.vue?vue&type=template&id=40422590&scoped=true&"
import script from "./Decline.vue?vue&type=script&lang=js&"
export * from "./Decline.vue?vue&type=script&lang=js&"
import style0 from "./Decline.vue?vue&type=style&index=0&id=40422590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40422590",
  null
  
)

export default component.exports